var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('v-btn',{attrs:{"color":"black darken-1","text":""},on:{"click":_vm.close}},[_vm._v("Cancelar")]),_c('v-btn',{class:_vm.styles ? _vm.styles : 'button-submit-green',attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }